/**
 * @generated SignedSource<<a3715c01262f8764094426d48f0b9e74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateProjectBudgetInput = {
  projects?: ReadonlyArray<ProjectInputType | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ProjectInputType = {
  id?: number | null;
  budgetBaseCurrency?: number | null;
  projectProgramBudgetType?: string | null;
};
export type updateProjectBudgetMutation$variables = {
  input: UpdateProjectBudgetInput;
};
export type updateProjectBudgetMutation$data = {
  readonly updateProjectBudget: {
    readonly clientMutationId: string | null;
  } | null;
};
export type updateProjectBudgetMutation = {
  variables: updateProjectBudgetMutation$variables;
  response: updateProjectBudgetMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateProjectBudgetPayload",
    "kind": "LinkedField",
    "name": "updateProjectBudget",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateProjectBudgetMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateProjectBudgetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bf02657da9ce39a3573101b44ed02ea8",
    "id": null,
    "metadata": {},
    "name": "updateProjectBudgetMutation",
    "operationKind": "mutation",
    "text": "mutation updateProjectBudgetMutation(\n  $input: UpdateProjectBudgetInput!\n) {\n  updateProjectBudget(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "6faf650bd58c5a049951a974d8e2c4b6";

export default node;
